import * as Yup from 'yup';

export default (isRequired) => {
  if (isRequired) {
    return Yup.object().shape({
      ackInfo: Yup.string()
        .required('Ack Detail Info is required')
        .max(2500, 'Ack Detail Info maximum 2500 characters'),
    });
  } else {
    return Yup.object().shape({
      ackInfo: Yup.string().max(
        2500,
        'Ack Detail Info maximum 2500 characters',
      ),
    });
  }
};
